import { ControlEventType, ControlPropertyType } from '../../../enums';
import { OptionProperty } from '../../select/enums';

export const RadioOptionProperty = OptionProperty;

export const RadioPropertyType = {
  ...ControlPropertyType,
  Options: 'options',
  Orientation: 'orientation',
};

export const RadioEventType = {
  ...ControlEventType,
};
